/** Query param for focused thread (expanded view). camelCase matches TS / GraphQL conventions. */
export const FOCUS_MESSAGE_QUERY_KEY = 'focusMessageId';

/** Max length for collapsed child message preview. */
export const THREAD_MESSAGE_SUMMARY_MAX_LENGTH = 150;
